import axios from "axios";
import { api } from "../../../api";

const root = process.env.REACT_APP_BACKEND_FINANCE_URL;
const route = api(`${root}/CompanyFund`);
const token = JSON.parse(localStorage.getItem("user"))?.userToken;

/**ALL API CALL FUNCTIONS EXPORTED AS AN OBJECT OF METHODS */

const AnalyseCompanyFundServices = {
  //
  async FetchAccounts() {
    try {
      let { data } = await axios.get(
        `${root}/accountledger/getallaccounts?PageSize=100&PageNumber=1`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      // console.log({ accounts: data})
      return data?.responseObject?.pageItems;
    } catch (e) {
      console.log({ err: e.response.data || e });
    }
  },
  // Upload bank statement
  async UploadBankStatement(formData) {
    let { data } = await route.post(
      "/UploadBankStatementCommandHandler",
      formData,
      {
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "multipart/form-data",
        },
      }
    );
    // console.log({uploadStatement: data?.responseObject});

    return data;
  },

  // Upload bank statement
  async FinalUploadBankStatement(formData) {
    //{bankID, file}
    console.log({ formData });
    let { data } = await route.post(
      "/FinaliseUploadBankStatementCommandHandler",
      formData,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    console.log({ finalUploadStatement: data?.responseObject });

    return data;
  },

  // Get cashbook records
  async getCashbook({
    pageNumber,
    pageSize,
    search,
    startDate,
    endDate,
    accountName,
  }) {
    let dateFilter = `&StartDate=${startDate}&EndDate=${endDate}`;
    // console.log({string: `/CashbookQuery?PageSize=${pageSize}&PageNumber=${pageNumber}&Search=${search}${dateFilter}`})
    let { data } = await route.get(
      `/CashbookQuery?PageSize=${pageSize}&PageNumber=${pageNumber}&Search=${search}&AccountName=${accountName}`,
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );

    // console.log({CashBookData: data})

    return data;
  },

  // Investment recommendations
  async createRecommendation(formData) {
    let { data } = await route.post(`/CreateTreasuryCBIRequest`, formData, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    console.log({ data });
    return data;
  },

  async getAllRecommendations({
    pageNumber,
    pageSize,
    search,
    startDate,
    endDate,
    ApprovalStatus,
    ID,
  }) {
    try {
      // Construct query parameters dynamically
      let queryParams = [];

      if (pageNumber !== null && pageNumber !== undefined) {
        queryParams.push(`PageNumber=${pageNumber}`);
      }
      if (pageSize !== null && pageSize !== undefined) {
        queryParams.push(`PageSize=${pageSize}`);
      }
      if (search !== null && search !== undefined && search !== "") {
        queryParams.push(`AccountName=${encodeURIComponent(search)}`);
      }
      if (startDate !== null && startDate !== undefined && startDate !== "") {
        queryParams.push(`StartDate=${encodeURIComponent(startDate)}`);
      }
      if (endDate !== null && endDate !== undefined && endDate !== "") {
        queryParams.push(`EndDate=${encodeURIComponent(endDate)}`);
      }
      if (ApprovalStatus !== null && ApprovalStatus !== undefined) {
        queryParams.push(`ApprovalStatus=${ApprovalStatus}`);
      }
      if (ID !== null && ID !== undefined) {
        queryParams.push(`ID=${ID}`);
      }

      // Join the query parameters to form the URL
      const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

      let { data } = await route.get(`/GetAllInvestibleBalance${queryString}`, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      console.log({ getAllRecommendations: data });
      return data;
    } catch (error) {
      console.log({ invstibleError: error });
    }
  },

  async editRecommendation(formData) {
    let { data } = await route.post(`/UpdateTreasuryCBIRequest`, formData, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return data;
  },

  async cancelRecommendation(id) {
    let { data } = await route.post(
      `/DeleteTreasuryCBIRequest`,
      { id },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    console.log({ data });
    return data;
  },
  async approveRecommendation(requestId) {
    let { data } = await route.post(
      `/ApproveInvestibleBalance`,
      { requestId },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    console.log({ data });
    return data;
  },
  async declineRecommendation({ requestId, comment }) {
    let { data } = await route.post(
      `/ApproveInvestibleBalanceController`,
      { requestId },
      {
        headers: {
          Authorization: "Bearer " + token,
        },
      }
    );
    console.log({ data });
    return data.responseObject;
  },

  // Get Account Ledger list (All banks)
  async getAllBanks() {
    try {
      let { data } = await axios.get(
        "https://bpmapi-dev.nlpcpfa.com/FinanceService/api/AccountLedger/GetAllAccounts?PageSize=100&PageNumber=1",
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      return data.responseObject.pageItems;
    } catch (e) {
      console.log({ deptError: e.response.data || e });
      return e.response.data;
    }
  },

  // Keywords
  async createKeyword(formData) {
    try {
      console.log({ formData });
      let { data } = await route.post("/CreateTreasuryKeyword", formData, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      console.log({ createKeyword: data });

      return data;
    } catch (e) {
      console.log({ err: e.response.data || e });
    }
  },
  async previewKeywordBatchUpload(formData) {
    try {
      console.log({ formData });
      let { data } = await route.post("/uploadtreasurykeyword", formData, {
        headers: {
          Authorization: "Bearer " + token,
          "Content-type": "multipart/form-data",
        },
      });
      console.log({ previewKeyword: data });

      return data;
    } catch (e) {
      console.log({ err: e.response.data || e });
    }
  },
  async finaliseKeywordBatchUpload(formData) {
    try {
      console.log({ formData });
      let { data } = await route.post(
        "/finalisetreasurykeywordupload",
        formData,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      console.log({ finaliseBatchUpload: data });

      return data;
    } catch (e) {
      console.log({ err: e.response.data || e });
    }
  },
  async getKeywords({ PageNumber, PageSize, Search, Position }) {
    try {
      let { data } = await route.get(
        `/GetAllTreasuryKeywords?PageSize=${PageSize}&PageNumber=${PageNumber}&Search=${Search}&Position=${Position}`,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      console.log({ getKeywords: data });

      return data;
    } catch (e) {
      console.log({ errKeyword: e.response.data || e });
    }
  },
  async updateKeyword(formData) {
    try {
      let { data } = await route.post(
        "/UpdateTreasuryKeywordController",
        formData,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      console.log({ updateKeyword: data });

      return data;
    } catch (e) {
      console.log({ err: e.response.data || e });
    }
  },
  async deleteKeyword({ id }) {
    try {
      let { data } = await route.post(
        "/DeleteTreasuryKeyword",
        { id },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );
      console.log({ deleteKeyword: data });

      return data;
    } catch (e) {
      console.log({ err: e.response.data || e });
    }
  },

  // Get all created table data
  // async getCostServices({Search, DeptID, EmployeeID, BranchID, CostClassID, PageSize, PageNumber}){
  //     try{
  //     let { data } = await route.get(`/CostCenter/all?Search=&CostClassID=2&PageSize=${PageSize}&PageNumber=${PageNumber}`,
  //     {
  //         headers: {
  //             Authorization: 'Bearer ' + token,
  //         }
  //     })

  //     console.log({getCostServices: data})

  //     return data;
  //     }
  //     catch (err) {
  //         console.log({getCostError: err.response.data || err})
  //     }
  // },

  // //Get single cost service
  // async getCostService(id){
  //     try{
  //         let { data } = await route.get(`/CostCenter/${id}`, {
  //             headers: {
  //                 Authorization: 'Bearer ' + token
  //             }
  //         })
  //         console.log({getCostService: data})
  //         return data.responseObject;
  //     }catch(err){
  //         console.log({err: err.response.data || err})
  //     }
  // },

  // //Update the cost service
  // async updateCostService(formData){
  //     let { data } = await route.post('/CostCenter/update', formData, {
  //         headers: {
  //             Authorization: 'Bearer ' + token
  //         }
  //     })
  //     console.log({updateCostService: data})
  //     return data;
  // },

  // //Delete the cost service
  // async deleteCostService(id){
  //     let { data } = await route.post('/CostCenterSetup/delete', {id}, {
  //         headers: {
  //             Authorization: 'Bearer ' + token
  //         }
  //     })
  //     console.log({deleteCostService: data})
  //     return data;
  // },
};
export default AnalyseCompanyFundServices;
